import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../../../Services/crud.service";
import { LogedInUserService } from "../../../../Services/loged-in-user.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  NgbAccordionCollapse,
  NgbAccordionConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DeleteConfirmationDialogComponent } from "src/app/Pages/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { FormStateService } from "src/app/Services/form.service";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { LoadingService } from "src/app/Services/loading.service";
@Component({
  selector: "app-dynamic-workflow-form",
  templateUrl: "./dynamic-workflow-form.component.html",
  standalone: false,
  styles: [
    `
      .no-after-icon::after {
        display: none !important;
      }

      ::ng-deep .checked-box {
        accent-color: #032d55 !important; /* Your custom color, e.g., Bootstrap Primary */
      }
      ::ng-deep input[type="checkbox"] {
        width: 25px !important;
      }
      ::ng-deep input[type="checkbox"]:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e") !important;
        background-color: #032d55 !important;
      }
    `,
  ],
})
export class DynamicWorkflowFormComponent implements OnInit, OnChanges {
  @Input() addWorkflow = false;
  @Input() workflow = {};
  @Input() project;
  @Input() screen;
  @ViewChild("accordion", { static: false }) accordion: any;
  publishToDev: boolean = false;
  @Output() formSubmitted: EventEmitter<void> = new EventEmitter<void>();
  @Output() sendRestoSDE = new EventEmitter<boolean>();
  @Input() roles: any;
  @Input() isLanguageChanged = false;
  @Input() languageId;
  @Input() commonObject;
  form: UntypedFormGroup;

  currentTooltip;
  workflowSteps = [];
  selectedWorkflowStepLanguage = {};
  languageList = [];
  disableSave = false;
  publishToProd = false;
  publishToQA = false;
  versionList = [];
  @Input() selectedVersion;
  submitted = false;
  @Input() addStep = false;
  collapsedMap = new Map<number, boolean>();
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "yes",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  loadingSub;
  isLoading: boolean = false;
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private route: ActivatedRoute,
    config: NgbAccordionConfig,
    private router: Router,
    private dialog: MatDialog,
    private formStateService: FormStateService,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    config.closeOthers = true;
  }

  ngOnInit() {
    console.log("workflow", this.workflow);
    this.form = this.formBuilder.group({
      id: ["", Validators.required, ""],
      name: ["", Validators.required, ""],
      screenType: ["screenSpecific", Validators.required, ""],
      projectVersion: ["", ""],
      triggerElement: ["", ""],
      allowSkipOnDevice: ["", ""],
      iconType: ["", ""],
      showOn: ["", ""],
      feedback: ["", ""],
      style: ["", ""],
      elementSelector: ["", ""],
      roles: [""],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
    this.currentTooltip = Object.assign({}, this.workflow);

    this.form.patchValue(this.currentTooltip);
    this.getLanguages();
    if (!this.addWorkflow) {
      this.getWorkflowSteps(this.workflow["id"]);
      this.getlastPublishStage(this.currentTooltip.workflowId);
    }

    this.form.get("showOn").valueChanges.subscribe((value) => {
      this.toggleIconTypeAndStyleVisibility(value);
    });
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["commonObject"]) {
      if (
        this.commonObject["individualItem"] &&
        this.commonObject["individualItem"]["id"] === this.workflow["id"]
      ) {
        const selectedLangId = String(this.commonObject["languageId"]).trim();

        // ✅ Build final steps with preference for selected language
        const stepMap = new Map<string, any>();

        this.commonObject["individualItem"]["workflowSteps"].forEach((step) => {
          const key = step.displayStep;

          // If it's the selected language OR no entry exists yet
          if (!stepMap.has(key) || step.languageId === selectedLangId) {
            stepMap.set(key, step);
          }
        });

        this.workflowSteps = Array.from(stepMap.values());
      }
    }

    // throw new Error("Method not implemented.");
  }
  get f() {
    return this.form.controls;
  }
  saveWorkflow() {
    var payload = this.form.value;

    payload["elementSelector"] = this.form.value["elementSelector"];
    payload["elementData"] = {
      elementId:
        this.form.value["elementSelector"] == "Id" &&
        this.form.value["triggerElement"] != ""
          ? this.form.value["triggerElement"]
          : "",
      elementClass:
        this.form.value["elementSelector"] == "Class" &&
        this.form.value["triggerElement"] != ""
          ? this.form.value["triggerElement"]
          : "",
      elementPath:
        this.form.value["elementSelector"] == "Path" &&
        this.form.value["triggerElement"] != ""
          ? this.form.value["triggerElement"]
          : "",
      elementTagName:
        this.form.value["elementSelector"] == "Name" &&
        this.form.value["triggerElement"] != ""
          ? this.form.value["triggerElement"]
          : "",
      elementXPath:
        this.form.value["elementSelector"] == "XPath" &&
        this.form.value["triggerElement"] != ""
          ? this.form.value["triggerElement"]
          : "",
    };
    payload["screenManagementId"] = this.screen.id;
    payload["projectManagementId"] = this.project.id;
    payload["projectVersion"] = this.selectedVersion;
    payload["publishStage"] = "dev";
    payload["style"] = "";
    payload["roles"] = this.roles;
    var workflowPayload = {};

    workflowPayload["screenManagementId"] = this.screen.id;
    workflowPayload["projectManagementId"] = this.project.id;

    this.crudService.post(
      workflowPayload,
      (response) => {
        if (response) {
          payload["workflowId"] = response.id;
          this.crudService.post(
            payload,
            (responseFW) => {
              this.form.markAsPristine();
              this.form.markAsUntouched();
              this.publishToQA = true;
              this.currentTooltip = responseFW;
              this.addStep = true;
              this.workflow = response;
            },
            "currentWorkflowsDetails"
          );
        }
      },
      "workflows"
    );
  }
  toggleIconTypeAndStyleVisibility(value: string) {
    if (value === "icon") {
      this.form.get("iconType").enable();
      this.form.get("style").enable();
    } else {
      this.form.get("iconType").disable();
      this.form.get("style").disable();
    }
  }

  getlastPublishStage(workflowId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (response.publishStage == "dev") {
          self.publishToQA = true;
          self.publishToProd = false;
        } else if (response.publishStage == "qa") {
          self.publishToQA = false;
          self.publishToProd = true;
        } else if (response.publishStage == "prod") {
          self.publishToProd = false;
        }
      },
      `currentWorkflowsDetails/findOne?filter[order]=updatedAt DESC&filter[where][workflowId]=${workflowId}`
    );
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  onSubmit() {
    this.submitted = true;
    var self = this;

    // stop here if form is invalid
    if (this.form.invalid) return;

    // submit API call
    var { id } = this.form.value;

    var payload = {
      ...this.form.value,
      id: undefined,
      publishStage: "dev",
      workflowId: this.currentTooltip.workflowId,
      screenManagementId: this.screen.id,
      projectManagementId: this.project.id,
      elementData: this.form.value.triggerElement
        ? this.currentTooltip.elementData
        : null,
      roles:
        this.form.value.roles && this.form.value.roles.length > 0
          ? this.form.value.roles
          : null,
    };

    this.crudService.update(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        } else {
          self.toastr.success(
            "Workflow has been created successfully.",
            "Success"
          );
          self.formSubmitted.emit();

          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        }
      },
      "currentWorkflowsDetails/" + self.workflow["id"]
    );
    this.submitted = false;
    self.getlastPublishStage(this.currentTooltip.workflowId);
  }

  addWorkflowVisible(condition) {
    this.accordion.collapseAll();
    this.addStep = condition;
  }

  createWorkflowSteps(payload) {
    this.crudService.post(
      payload,
      (response) => {},
      "currentWorkflowDetailsSteps"
    );
  }

  onReset() {
    this.submitted = false;
    this.form.patchValue(this.currentTooltip);
    this.form.markAsPristine();
    this.formStateService.clearFormDirty();
  }

  onClickOfPublish(publishStage: string) {
    var self = this;
    if (this.form.invalid) return;
    var payload = {
      ...this.form.value,
      id: undefined,
      publishStage: publishStage,
      workflowId: this.currentTooltip.workflowId,
      screenManagementId: this.screen.id,
      projectManagementId: this.project.id,
      elementData: this.form.value.triggerElement
        ? this.currentTooltip.elementData
        : null,
      roles:
        this.form.value.roles && this.form.value.roles.length > 0
          ? this.form.value.roles
          : null,
    };

    console.log("paylaod here", payload);
    /*     this.crudService.update(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        } else {
          self.toastr.success(
            "Workflow has been published successfully.",
            "Success"
          );
          self.formSubmitted.emit();
          if (self.workflowSteps && self.workflowSteps.length) {
            self.workflowSteps.forEach(function (workflowstep) {
              var workflowStepPayload = {
                ...workflowstep,
                id: undefined,
                workflowsId: response.id,
              };
              self.createWorkflowSteps(workflowStepPayload);
            });
          }
          self.form.markAsPristine();
          self.formStateService.clearFormDirty();
        }
      },
      "currentWorkflowsDetails/" + self.workflow["id"]
    ); */
    self.getlastPublishStage(this.currentTooltip.workflowId);
  }

  getWorkflowSteps(workflowId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.workflowSteps = response;
          self.workflowSteps.forEach(function (pWorkflowStep) {
            self.selectedWorkflowStepLanguage[pWorkflowStep.id] =
              self.getLanguageName(self.project.primaryLanguage);
          });
        }
      },
      `currentWorkflowDetailsSteps?filter[order]=displayStep ASC&filter[where][status]="true"&filter[where][languageId]=${self.project.primaryLanguage}&filter[where][workflowsId]=${workflowId}`
    );
  }

  public onSelectedWorkflowLanguageChange(data: any): void {
    this.selectedWorkflowStepLanguage[data.id] = data.name;
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  getSelectedWorkflowStepLanguage(workflowStepId) {
    return this.selectedWorkflowStepLanguage[workflowStepId];
  }

  deleteStep(item) {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      panelClass: "custom-bg",
      data: {
        title: "Delete Workflow Step",
        paragraph: `Are you sure you want to delete this workflow step?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "Workflow step has been deleted successfully.",
                "Success"
              );
              this.getWorkflowSteps(this.currentTooltip.id);
            }
          },
          "currentWorkflowDetailsSteps/" + item.id
        );
      }
    });
  }

  onFormSubmitted(submittedStep) {
    // this.addWorkflowVisible(false);
    this.formSubmitted.emit();
  }
  recieveResfromWFS(val) {
    if (val) {
      this.addStep = false;
      this.addWorkflow = false;
      this.accordion.collapse(val.id);
      /*  this.publishToDev = true;
      this.publishToQA = false;
      this.publishToProd = false; */
      this.getWorkflowSteps(val.workflowsId);
    }
  }
}
